export default __webpack_public_path__ + "static/media/team-sherwin.81beaaf7.png";